import { createVanIconComponent } from "./van"

const HotSale = createVanIconComponent("hot-sale")
export default HotSale
